import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SlicePipe } from '@angular/common';

@Component({
  selector: 'app-grouped-districts-detail',
  templateUrl: './grouped-districts-detail.component.html',
  styleUrls: ['./grouped-districts-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SlicePipe, TranslatePipe]
})
export class GroupedDistrictsDetailComponent {
  public showAllCityParts: boolean;
  public splitLength = 20;
  readonly districtGroup = input<any>(undefined);

  public toggleShowAllCityParts() {
    this.showAllCityParts = !this.showAllCityParts;
  }
}
